/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MonthlyInputs */

const en_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const es_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const fr_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au mois`)
};

const de_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const ja_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1ヶ月あたり`)
};

const zh_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按月`)
};

const ar_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شهرياً`)
};

const id_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulanan`)
};

const it_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al Mese`)
};

const ru_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячно`)
};

const pt_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensal`)
};

const ko_val_monthly = /** @type {(inputs: Val_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월별`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Val_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_monthly = /** @type {((inputs?: Val_MonthlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MonthlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_monthly(inputs)
	if (locale === "es") return es_val_monthly(inputs)
	if (locale === "fr") return fr_val_monthly(inputs)
	if (locale === "de") return de_val_monthly(inputs)
	if (locale === "ja") return ja_val_monthly(inputs)
	if (locale === "zh") return zh_val_monthly(inputs)
	if (locale === "ar") return ar_val_monthly(inputs)
	if (locale === "id") return id_val_monthly(inputs)
	if (locale === "it") return it_val_monthly(inputs)
	if (locale === "ru") return ru_val_monthly(inputs)
	if (locale === "pt") return pt_val_monthly(inputs)
	return ko_val_monthly(inputs)
});